import { render, staticRenderFns } from "./DebtorContractModal.vue?vue&type=template&id=6b454a15&"
import script from "./DebtorContractModal.vue?vue&type=script&lang=js&"
export * from "./DebtorContractModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports